/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
// import CustomValuesHook from '../../Hooks/customValuesHook'
import Filtering from './filtering/index'
import Pagination from './pagination'
import './style.scss'
import InputFilter from './filtering/inputFilter'
import ExportExcellFile from './exportExcellFile'
import ScrollRender from './ScrollRender'


const GSPTable = ({
  apiCall = () => console.log("there isn't any API call action"),
  externalFilters = () => { return <></> },
  columns = [], dataList = { data: [] }, options,
  hasSorting = false,
  hasPaging = false,
  hasFiltering = false,
  isSearchByExternalBtn = false,
  loading = false,
  pageSize = 10,
  isStepScrolling = false,
  rowHeight = 37,
  headerHeight = 38,
  enableScrolling = true,
  searchBtnText = "Search",
  isExportExcell = false,
  customProps, divTable = false, theme = "", isInfinityScroll, setDisplayDataList, displayDataList,
  scrollPosition, setScrollPosition, externalPaging, isDynamicColumns, exportDataModel, customLoading, customCardView,
  setDataListFromItem = () => { console.log("there isn't any function for setDataListFromItem ") }
}) => {
  const [values, handleChange] = CustomValuesHook({
    disablePaging: !hasPaging,
    pageNumber: 1,
    pageSize: pageSize,
    whereConditionText: dataList.whereConditionText ? dataList.whereConditionText : '',
    sortText: dataList.sortText ? dataList.sortText : '',
    filterList: []
  })
  const [dataListToDisplay, setDataListToDisplay] = React.useState(displayDataList && Array.isArray(displayDataList) ? [...displayDataList] : [])
  const [pageNumber, setPageNumber] = React.useState()
  const [pageNumberFromPager, setPageNumberFromPager] = React.useState()
  const [loadProgress, setLoadProgress] = React.useState(0)

  const scrollContextProps = {
    enableScrolling,
    columns,
    divTable,
    options,
    hasSorting,
    handleChange,
    dataList,
    setDataListFromItem,
    customProps,
    isStepScrolling,
    rowHeight,
    setDataListToDisplay,
    setPageNumber,
    loading,
    headerHeight,
    pageNumberFromPager,
    dataListToDisplay,
    theme,
    isInfinityScroll, scrollPosition, setScrollPosition, isDynamicColumns, exportDataModel, customCardView
  }

  React.useEffect(() => {

    handleCallApi()
    setLoadProgress(1)
  }, [])
  React.useEffect(() => {
    if (isSearchByExternalBtn !== "" && loadProgress > 0) {

      if (loadProgress > 0) {
        handleCallApi()

      } else {
        setLoadProgress(loadProgress + 1)

      }
    }

  }, [values.whereConditionText])
  React.useEffect(() => {

    if (loadProgress > 0) {
      handleCallApi()
    } else {
      setLoadProgress(loadProgress + 1)

    }
  }, [values.pageNumber, values.sortText, values.pageSize])

  React.useEffect(() => {
    if (dataListToDisplay.length > 0) {
      if (setDisplayDataList) {
        setDisplayDataList([...dataListToDisplay])
      }
    }
  }, [dataListToDisplay])

  const handleCallApi = () => {
    apiCall(values)
  }


  return (
    <>

      <div>
        <div className='d-flex flex-row justify-content-between'>
          {hasFiltering && <Filtering
            searchBtnText={searchBtnText}
            columns={columns}
            setFilterQuery={handleChange}
            values={values}
            callApi={isSearchByExternalBtn ? handleCallApi : false}
            externalFilters={externalFilters ? externalFilters(values, handleChange) : false}
          />}

          {isExportExcell && <ExportExcellFile
            columns={columns}
            dataList={dataList.data}
          />}
        </div>

        <div className={`table-context ${theme}`}>
          {loading && <>
            {customLoading ? customLoading() : <div className='table-loading'>
              <div className="spinner-border" role="status" aria-hidden="true"></div>
            </div>}
          </>}
          <ScrollRender
            {...scrollContextProps}
          />
        </div>


        {hasPaging && !isInfinityScroll && <Pagination
          totalCount={dataList.totalCount}
          setPage={setPageNumberFromPager}
          pageNumber={pageNumber}
          pageSize={values.pageSize}
          changePageValues={handleChange}
          externalPaging={externalPaging}
          enableScrolling={enableScrolling}
        />}

      </div>

    </>
  )
}

export default GSPTable


const CustomValuesHook = (props) => {
  const [state, setState] = React.useState({ ...props })

  const handleChange = (e) => {
    for (let prop in e) {
      setState((state) => ({
        ...state,
        [prop]: e[prop]
      }))
    }

  }

  const handleResetState = () => {
    setState({ ...props })
  }
  return [state, handleChange, handleResetState];
}



export { InputFilter, ExportExcellFile };

